<div class="np-form-control dx-fieldset">
    <dx-validation-group id="MAIN">
      <div *ngIf="context.productTranslation != null" class="dx-field">
            <div class="dx-field-label"></div>
            <div class="dx-field-value d-flex flex-row">
                <div class="flex-fill align-self-center">
                    <img class="flag" src="images/flags/de.gif" />
                    <b>{{ 'Deutsch' | translate }}</b>
                </div>
                <div class="flex-fill pl-2 align-self-center">
                    <img class="flag" src="images/flags/{{ getLanguageFlag(selectedTranslateLanguage) }}" />
                    <b>{{ translateLanguage(selectedTranslateLanguage) }}</b>
                </div>
            </div>
        </div>

        <div class="container-fluid px-0">
            <div class="row g-3">

                <!-- PRODUKTINFOS + HERSTELLERINFOS -->
                <div class="col-12 col-lg-6 d-flex">
                    <div class="np-section h-100 w-100">
                        <div class="np-section-header">{{ 'Produktinformationen' | translate }}</div>

                        <!-- SUPPLIER_PID -->
                        <div class="np-field np-product-number">
                          <a *ngIf="loginService.hasAddonWawiErp && !readOnly('productUniqueSID') && !context.templateView"
                               class="np-inline-action"
                               href=""
                               (click)="getSupplierPid(); $event.preventDefault(); $event.stopPropagation()">
                                {{ 'Eindeutige Produktnummer (PID) zuweisen' | translate }}
                            </a>

                          <np-inputControl [showPlaceLabel]="context.model.supplierPid?.length > 0"
                                             [suppressLinkButton]="true"
                                             field="SUPPLIER_PID"
                                             labelText="{{ 'Produktnummer' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-text-box (onValueChanged)="update($event, 'SUPPLIER_PID')"
                                                 [(value)]="context.model.supplierPid"
                                                 [readOnly]="readOnly('productId') || context.massDataChangeMode"
                                                 [showClearButton]="showClearButton('SUPPLIER_PID')">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('SUPPLIER_PID')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <!-- SUPPLIER_ALT_PID -->
                      <div class="np-field" *ngIf="!context.isPrint">
                        <np-inputControl [showPlaceLabel]="context.model.supplierAltAid?.length > 0" field="SUPPLIER_ALT_PID" labelText="{{ 'alternative Produktnummer' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-text-box (onValueChanged)="update($event, 'SUPPLIER_ALT_PID')"
                                                 [(value)]="context.model.supplierAltAid"
                                                 [readOnly]="readOnlyForLinkedFields('SUPPLIER_ALT_PID') || readOnly('productAltId') || context.massDataChangeMode"
                                                 [showClearButton]="showClearButton('SUPPLIER_ALT_PID')">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('SUPPLIER_ALT_PID')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <!-- INTERNATIONAL_PID + TYPE -->
                        <div class="np-field">
                            <div class="row g-2">
                                <div class="col-12 col-md-8">
                                  <np-inputControl [showPlaceLabel]="context.model.internationalPid?.length > 0"
                                                     field="INTERNATIONAL_PID"
                                                     labelText="{{ 'Internationale ID' | translate }}">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'INTERNATIONAL_PID')"
                                                         [(value)]="context.model.internationalPid"
                                                         [readOnly]="readOnlyForLinkedFields('INTERNATIONAL_PID') || readOnly('productIntId') ||context.massDataChangeMode"
                                                         [showClearButton]="showClearButton('INTERNATIONAL_PID')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('INTERNATIONAL_PID')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>

                                <div class="col-12 col-md-4">
                                  <np-inputControl
                                      [showPlaceLabel]="context.model.internationalPidType?.length > 0"
                                                     [suppressLabel]="false"
                                                     labelText="{{ 'TYP' | translate }}"
                                                     field="INTERNATIONAL_PID_TYPE">
                                        <div class="contentSlot" slot="content">
                                            <dx-autocomplete (onValueChanged)="update($event, 'INTERNATIONAL_PID_TYPE')"
                                                             [(value)]="context.model.internationalPidType"
                                                             [dataSource]="internationalPidType"
                                                             [minSearchLength]="0"
                                                             [readOnly]="readOnlyForLinkedFields('INTERNATIONAL_PID_TYPE') || readOnly('productIntIdType')"
                                                             [showClearButton]="showClearButton('INTERNATIONAL_PID_TYPE')"
                                                             [showDropDownButton]="!readOnlyForLinkedFields('INTERNATIONAL_PID_TYPE')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('INTERNATIONAL_PID_TYPE')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-autocomplete>
                                        </div>
                                    </np-inputControl>
                                </div>
                            </div>
                        </div>

                      <div class="np-field" *ngIf="!context.isPrint">
                        <np-inputControl
                            [showPlaceLabel]="context.model.remarks?.length > 0"
                            [showTranslationPlaceLabel]="context.productTranslation?.remarks?.length > 0"
                                             field="REMARKS"
                                             labelText="{{ 'Bemerkung' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-text-box (onValueChanged)="update($event, 'REMARKS')"
                                                 [(value)]="context.model.remarks"
                                                 [readOnly]="readOnlyForLinkedFields('REMARKS') || readOnly('productTranslation')"
                                                 [showClearButton]="showClearButton('REMARKS')">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('REMARKS')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>

                                <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                                  <dx-text-box (onValueChanged)="translationUpdate(context.model.remarks, $event.value)"
                                               [(value)]="context.productTranslation.remarks"
                                                 [readOnly]="readOnly('productTranslation')"
                                                 [showClearButton]="true"></dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-6 d-flex">
                    <div class="np-section h-100 w-100">
                        <div class="np-section-header">{{ 'Herstellerinformationen' | translate }}</div>
                        <div class="np-field">
                          <np-inputControl
                              [showPlaceLabel]="context.model.manufacturerTypeDescr?.length > 0"
                              [showTranslationPlaceLabel]="context.productTranslation?.manufacturerTypeDescr?.length > 0"
                                             field="MANUFACTURER_TYPE_DESCR"
                                             labelText="{{ 'Herstellerbezeichnung' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-text-box (onValueChanged)="update($event, 'MANUFACTURER_TYPE_DESCR')"
                                                 [(value)]="context.model.manufacturerTypeDescr"
                                                 [height]="46"
                                                 [readOnly]="readOnlyForLinkedFields('MANUFACTURER_TYPE_DESCR') || readOnly('productPName')">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('MANUFACTURER_TYPE_DESCR')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>

                                <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                                  <dx-text-area (onValueChanged)="translationUpdate(context.model.manufacturerTypeDescr, $event.value)"
                                                [(value)]="context.productTranslation.manufacturerTypeDescr"
                                                  [height]="46"
                                                  [readOnly]="readOnly('productPName')"></dx-text-area>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field" *ngIf="!loginService.hasAddonDataSources">
                          <np-inputControl
                              [showPlaceLabel]="context.model.manufacturerName?.length > 0"
                              [showTranslationPlaceLabel]="context.productTranslation?.manufacturerName?.length > 0"
                                             [suppressTranslation]="false"
                                             field="MANUFACTURER_NAME"
                                             labelText="{{ 'Herstellername' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-text-box (onValueChanged)="update($event, 'MANUFACTURER_NAME')"
                                                 [(value)]="context.model.manufacturerName"
                                                 [readOnly]="readOnlyForLinkedFields('MANUFACTURER_NAME') || readOnly('productManuName')"
                                                 [showClearButton]="showClearButton('MANUFACTURER_NAME')"
                                                 class="validationBlue">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('MANUFACTURER_NAME')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>

                                <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                                  <dx-text-box (onValueChanged)="translationUpdate(context.model.manufacturerName, $event.value)"
                                               [(value)]="context.productTranslation.manufacturerName"
                                                 [readOnly]="readOnly('productManuName')"
                                                 [showClearButton]="true"
                                                 class="validationBlue"></dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field" *ngIf="loginService.hasAddonDataSources">
                          <np-inputControl
                              [showPlaceLabel]="context.model.manufacturerName?.length > 0"
                              [showTranslationPlaceLabel]="context.productTranslation?.manufacturerName?.length > 0"
                                             [suppressTranslation]="false"
                                             field="MANUFACTURER_NAME"
                                             labelText="{{ 'Herstellername' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-select-box (onCustomItemCreating)="onManufacturerCustomItemCreating($event)"
                                                   (onValueChanged)="update($event, 'MANUFACTURER_NAME')"
                                                   [(value)]="context.model.manufacturerName"
                                                   [acceptCustomValue]="true"
                                                   [dropDownOptions]="dropDownCfg"
                                                   [items]="manufacturerDataSources"
                                                   [readOnly]="readOnlyForLinkedFields('MANUFACTURER_NAME') || readOnly('productManuName')"
                                                   [searchEnabled]="true"
                                                   [searchExpr]="['name', 'brandName', 'alternativeNames']"
                                                   [showClearButton]="showClearButton('MANUFACTURER_NAME')"
                                                   class="validationBlue"
                                                   displayExpr="name"
                                                   placeholder=""
                                                   valueExpr="name">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('MANUFACTURER_NAME')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>

                                <div *ngIf="hasTranslation" class="translationSlot" slot="translation">
                                  <dx-text-box (onValueChanged)="translationUpdate(context.model.manufacturerName, $event.value)"
                                               [(value)]="context.productTranslation.manufacturerName"
                                                 [readOnly]="readOnly('productManuName')"
                                                 [showClearButton]="true"
                                                 class="validationBlue"></dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                      <div class="np-field" *ngIf="loginService.hasAddonBauvista">
                        <np-inputControl
                            [showPlaceLabel]="context.model.manufacturerGln?.length > 0"
                                             field="MANUFACTURER_GLN"
                                             labelText="{{ 'Hersteller-GLN' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-text-box (onValueChanged)="update($event, 'MANUFACTURER_GLN')"
                                                 [(value)]="context.model.manufacturerGln"
                                                 [readOnly]="readOnlyForLinkedFields('MANUFACTURER_GLN')  || readOnly('MANUFACTURER_GLN')"
                                                 [showClearButton]="showClearButton('MANUFACTURER_GLN')"
                                                 class="validationBlue">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('MANUFACTURER_GLN')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                      <div class="np-field" *ngIf="!context.isPrint">
                        <np-inputControl
                            [showPlaceLabel]="context.model.manufacturerAid?.length > 0"
                                             field="MANUFACTURER_PID"
                                             labelText="{{ 'Herstellerartikelnummer' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-text-box (onValueChanged)="update($event, 'MANUFACTURER_PID')"
                                                 [(value)]="context.model.manufacturerAid"
                                                 [readOnly]="readOnlyForLinkedFields('MANUFACTURER_PID') || readOnly('productManuAid') ||context.massDataChangeMode"
                                                 [showClearButton]="showClearButton('MANUFACTURER_PID')"
                                                 class="validationBlue">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('MANUFACTURER_PID')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field" *ngIf="loginService.hasAddonDataSources">
                          <np-inputControl [showPlaceLabel]="context.model.brandName?.length > 0"
                                           [showTranslationPlaceLabel]="context.productTranslation?.brandName?.length > 0"
                                           field="BRAND_NAME" labelText="{{ 'Markenname' | translate }}">
                                <div class="contentSlot" slot="content">
                                    <dx-select-box (onValueChanged)="update($event, 'BRAND_NAME')"
                                                   [(value)]="context.model.brandName"
                                                   [acceptCustomValue]="true"
                                                   [items]="possibleBrandNames"
                                                   [openOnFieldClick]="true"
                                                   [readOnly]="readOnlyForLinkedFields('BRAND_NAME') || readOnly('productBrandName')"
                                                   [searchEnabled]="true"
                                                   [showClearButton]="showClearButton('BRAND_NAME')"
                                                   placeholder="">
                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                      *ngIf="!context.templateView"
                                                      validationGroup="MAIN">
                                            <dxi-validation-rule [validationCallback]="validationService.validateField('BRAND_NAME')"
                                                                 type="async"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                            </np-inputControl>
                        </div>
                    </div>
                </div>

              <div class="col-12" *ngIf="loginService.hasAddonEDENUMBERS">
                    <div class="np-section">
                        <div class="np-section-header">{{ 'EDE Nummern' | translate }}</div>

                        <div class="row g-3">
                            <div class="col-12 col-lg-6">
                                <div class="np-field">
                                  <np-inputControl
                                      [showPlaceLabel]="context.model.edeNumber1?.length > 0"
                                                     field="EDE_NUMBER_1"
                                                     labelText="{{ 'EDE Nummer' | translate }} 1">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'EDE_NUMBER_1')"
                                                         [(value)]="context.model.edeNumber1"
                                                         [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_1') || readOnly('productEDENumber1')"
                                                         [showClearButton]="showClearButton('EDE_NUMBER_1')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('EDE_NUMBER_1')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>

                                <div class="np-field">
                                  <np-inputControl
                                      [showPlaceLabel]="context.model.edeNumber2?.length > 0"
                                                     field="EDE_NUMBER_2"
                                                     labelText="{{ 'EDE Nummer' | translate }} 2">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'EDE_NUMBER_2')"
                                                         [(value)]="context.model.edeNumber2"
                                                         [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_2') || readOnly('productEDENumber2')"
                                                         [showClearButton]="showClearButton('EDE_NUMBER_2')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('EDE_NUMBER_2')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>

                                <div class="np-field mb-0">
                                  <np-inputControl
                                      [showPlaceLabel]="context.model.edeNumber3?.length > 0"
                                                     field="EDE_NUMBER_3"
                                                     labelText="{{ 'EDE Nummer' | translate }} 3">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'EDE_NUMBER_3')"
                                                         [(value)]="context.model.edeNumber3"
                                                         [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_3') || readOnly('productEDENumber3')"
                                                         [showClearButton]="showClearButton('EDE_NUMBER_3')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('EDE_NUMBER_3')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="np-field">
                                  <np-inputControl
                                      [showPlaceLabel]="context.model.edeNumber4?.length > 0"
                                                     field="EDE_NUMBER_4"
                                                     labelText="{{ 'EDE Nummer' | translate }} 4">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'EDE_NUMBER_4')"
                                                         [(value)]="context.model.edeNumber4"
                                                         [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_4') || readOnly('productEDENumber4')"
                                                         [showClearButton]="showClearButton('EDE_NUMBER_4')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('EDE_NUMBER_4')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>

                                <div class="np-field mb-0">
                                  <np-inputControl
                                      [showPlaceLabel]="context.model.edeNumber5?.length > 0"
                                                     field="EDE_NUMBER_5"
                                                     labelText="{{ 'EDE Nummer' | translate }} 5">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'EDE_NUMBER_5')"
                                                         [(value)]="context.model.edeNumber5"
                                                         [readOnly]="readOnlyForLinkedFields('EDE_NUMBER_5') || readOnly('productEDENumber5')"
                                                         [showClearButton]="showClearButton('EDE_NUMBER_5')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('EDE_NUMBER_5')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

              <div class="col-12">
                    <div class="np-section">
                        <div class="np-section-header">{{ 'Weitere Informationen' | translate }}</div>

                        <div class="row g-3">
                            <div class="col-12 col-lg-6">
                              <div class="np-field" *ngIf="!context.isPrint">
                                <np-inputControl
                                    [showPlaceLabel]="context.model.keywords?.length > 0"
                                                     field="KEYWORDS"
                                                     labelText="{{ 'Suchbegriffe' | translate }}">
                                        <div class="contentSlot" slot="content">
                                            <dx-tag-box (onValueChanged)="update($event, 'KEYWORDS')"
                                                        [(value)]="context.model.keywords"
                                                        [acceptCustomValue]="true"
                                                        [readOnly]="readOnlyForLinkedFields('KEYWORDS') || readOnly('productKeywords')"
                                                        class="validationOrange"
                                                        noDataText=""
                                                        placeholder="">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('KEYWORDS')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-tag-box>
                                        </div>
                                    </np-inputControl>
                                </div>

                                <!--PrintIndex-->
                              <div *ngIf="loginService.hasAddonPRINT && !context.isPrint" class="np-field">
                                <np-inputControl
                                    [showPlaceLabel]="context.model.printIndexe?.length > 0"
                                                     labelText="{{ 'PRINTINDEXE' | translate }}"
                                    field="PRINTINDEXE">
                                        <div slot="content" class="contentSlot">
                                          <dx-tag-box [(value)]="context.model.printIndexe"
                                                        placeholder=""
                                                        [readOnly]="readOnlyForLinkedFields('PRINTINDEXE') || readOnly('productPrintIndexe')"
                                                        (onValueChanged)="update($event, 'PRINTINDEXE')"
                                                        [acceptCustomValue]="true"
                                                        noDataText=""
                                                        class="validationOrange">
                                            <dx-validator *ngIf="!context.templateView"
                                                              validationGroup="MAIN"
                                                              (onInitialized)="validationService.startAutomaticValidation($event)">
                                                    <dxi-validation-rule type="async"
                                                                         [validationCallback]="validationService.validateField('PRINTINDEXE')"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-tag-box>
                                        </div>
                                    </np-inputControl>
                                </div>
                                

                              <div class="np-field" *ngIf="loginService.hasAddonPRODUCT_DETAILS && !context.isPrint">
                                <np-inputControl
                                    [showPlaceLabel]="context.model.erpGroupBuyer?.length > 0"
                                                     field="ERP_GROUP_BUYER"
                                                     labelText="{{ 'ERP Gruppe Käufer' | translate }}">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'ERP_GROUP_BUYER')"
                                                         [(value)]="context.model.erpGroupBuyer"
                                                         [readOnly]="readOnlyForLinkedFields('ERP_GROUP_BUYER') || readOnly('productEDEGroupBuyer')"
                                                         [showClearButton]="showClearButton('ERP_GROUP_BUYER')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('ERP_GROUP_BUYER')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>

                              <div class="np-field mb-0" *ngIf="loginService.hasAddonPRODUCT_DETAILS && !context.isPrint">
                                <np-inputControl
                                    [showPlaceLabel]="context.model.buyerAid?.length > 0"
                                                     field="BUYER_AID"
                                                     labelText="{{ 'Käufer Artikelnummer' | translate }}">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'BUYER_AID')"
                                                         [(value)]="context.model.buyerAid"
                                                         [readOnly]="readOnlyForLinkedFields('BUYER_AID') || readOnly('productBuyerAid')"
                                                         [showClearButton]="showClearButton('BUYER_AID')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('BUYER_AID')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="np-field">
                                    <div class="row g-2 align-items-end">
                                        <div class="col">
                                          <np-inputControl [suppressPlaceLabel]="true"
                                                             field="IS_DISCONTINUED"
                                                             labelText="{{ 'Auslaufprodukt' | translate }}">
                                                <div class="contentSlot np-others" slot="content">
                                                    <np-booleanRadioGroup (onValueChanged)="update($event, 'IS_DISCONTINUED')"
                                                                          [(value)]="context.model.isDiscontinued"
                                                                          [fieldName]="validationService.fieldNames.isDiscontinued"
                                                                          [readOnly]="readOnlyForLinkedFields('IS_DISCONTINUED') || readOnly('productDiscontinued')"
                                                                          [templateView]="context.templateView"
                                                                          validatorValidationGroup="MAIN"></np-booleanRadioGroup>
                                                </div>
                                            </np-inputControl>
                                        </div>

                                      <div class="col-auto" *ngIf="context.model.isDiscontinued == true">
                                        <np-inputControl
                                            [showPlaceLabel]="context.model.discontinuedDate != null"
                                                             [suppressLabel]="true"
                                                             field="DISCONTINUED_DATE">
                                                <div class="contentSlot" slot="content">
                                                    <dx-date-box (onValueChanged)="update($event, 'DISCONTINUED_DATE')"
                                                                 [(value)]="context.model.discontinuedDate"
                                                                 [readOnly]="readOnlyForLinkedFields('DISCONTINUED_DATE') || readOnly('productDiscontinuedDate')"
                                                                 [showClearButton]="showClearButton('DISCONTINUED_DATE')"
                                                                 displayFormat="dd.MM.yyyy"
                                                                 id="date"
                                                                 type="date"
                                                                 valueChangeEvent="focusout">
                                                        <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                                      *ngIf="!context.templateView"
                                                                      validationGroup="MAIN">
                                                            <dxi-validation-rule [validationCallback]="validationService.validateField('DISCONTINUED_DATE')"
                                                                                 type="async"></dxi-validation-rule>
                                                        </dx-validator>
                                                    </dx-date-box>
                                                </div>
                                            </np-inputControl>
                                        </div>
                                    </div>
                                </div>

                              <div class="np-field">
                                <np-inputControl
                                    [showPlaceLabel]="context.model.effectiveDate != null"
                                                     field="EFFECTIVE_DATE"
                                                     labelText="{{ 'Gültig ab' | translate }}">
                                        <div class="contentSlot" slot="content">
                                            <dx-date-box (onValueChanged)="update($event, 'EFFECTIVE_DATE')"
                                                         [(value)]="context.model.effectiveDate"
                                                         [readOnly]="readOnlyForLinkedFields('EFFECTIVE_DATE') || readOnly('EFFECTIVE_DATE')"
                                                         [showClearButton]="showClearButton('EFFECTIVE_DATE')"
                                                         displayFormat="dd.MM.yyyy"
                                                         type="date"
                                                         valueChangeEvent="focusout">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('EFFECTIVE_DATE')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-date-box>
                                        </div>
                                    </np-inputControl>
                                </div>

                                <!-- STATUS -->
                                <div class="np-field">
                                  <np-inputControl
                                      [showPlaceLabel]="context.model.states?.length > 0"
                                                     field="STATUS"
                                                     labelText="{{ 'Produktstatus' | translate }}">
                                        <div class="contentSlot" slot="content">
                                            <dx-tag-box (onValueChanged)="updateState($event, 'STATUS')"
                                                        [(value)]="context.model.states"
                                                        [acceptCustomValue]="true"
                                                        [items]="productStates"
                                                        [readOnly]="readOnlyForLinkedFields('STATUS') || readOnly('productState')"
                                                        noDataText=""
                                                        placeholder="">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('STATUS')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-tag-box>
                                        </div>
                                    </np-inputControl>
                                </div>

                                <!-- ERP_GROUP_SUPPLIER -->
                              <div class="np-field mb-0" *ngIf="loginService.hasAddonPRODUCT_DETAILS && !context.isPrint">
                                <np-inputControl
                                    [showPlaceLabel]="context.model.erpGroupSupplier?.length > 0"
                                                     field="ERP_GROUP_SUPPLIER"
                                                     labelText="{{ 'ERP Gruppe Verkäufer' | translate }}">
                                        <div class="contentSlot" slot="content">
                                            <dx-text-box (onValueChanged)="update($event, 'ERP_GROUP_SUPPLIER')"
                                                         [(value)]="context.model.erpGroupSupplier"
                                                         [readOnly]="readOnlyForLinkedFields('ERP_GROUP_SUPPLIER') || readOnly('productEDEGroupSupplier')"
                                                         [showClearButton]="showClearButton('ERP_GROUP_SUPPLIER')">
                                                <dx-validator (onInitialized)="validationService.startAutomaticValidation($event)"
                                                              *ngIf="!context.templateView"
                                                              validationGroup="MAIN">
                                                    <dxi-validation-rule [validationCallback]="validationService.validateField('ERP_GROUP_SUPPLIER')"
                                                                         type="async"></dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </np-inputControl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </dx-validation-group>
    <dx-load-panel [focusStateEnabled]="false"
                   [shading]="false"
                   [showIndicator]="true"
                   [visible]="isLoading"></dx-load-panel>
</div>

<np-edit-datasource (saved)="onEditSaved($event)"
                    [(visible)]="popupVisible"
                    [dataSource]="newAddedDatasource"
                    [editMode]="false"></np-edit-datasource>

<footer *ngIf="(isMaster() && !readOnly('productLinkAll') && !context.templateView) || (loginService.hasAddonODOO && !readOnly('productUniqueSID') && !context.templateView) || loginService.hasAddonDEVELOPMENT" class="np-footer">
    <dx-button stylingMode="outlined"
               *ngIf="(isMaster() && !readOnly('productLinkAll') && !context.templateView)"
               type="default"
               text="{{ 'Alle Felder verknüpfen' | translate }}"
               (onClick)="linkAllFields()"></dx-button>
    <dx-button stylingMode="outlined"
               *ngIf="loginService.hasAddonODOO && !readOnly('productUniqueSID') && !context.templateView"
               type="default"
               text="{{ 'Ins ArtikelnummerMapping eintragen' | translate }}"
               (onClick)="createSupplierPidMapping()"></dx-button>
    <dx-button stylingMode="outlined"
               *ngIf="loginService.hasAddonScrapper"
               type="default"
               icon="tips"
               [disabled]="readOnly('productScrapeProduct')"
               text="{{ 'Produkt im Netz suchen' | translate }}"
               (onClick)="scrapeProduct()">
    </dx-button>
</footer>
